import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 30,
    fontSize: 10,
  },
  header: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  subHeader: {
    fontSize: 12,
    marginBottom: 15,
    textAlign: 'center',
    color: '#666666',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 10,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    padding: 5,
  },
  tableCol: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 9,
    textAlign: 'center',
  },
  totalRow: {
    backgroundColor: '#e8f4f8',
    fontWeight: 'bold',
  },
  summary: {
    marginTop: 20,
    padding: 15,
    backgroundColor: '#f9f9f9',
    borderRadius: 5,
  },
  summaryTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  summaryItem: {
    fontSize: 11,
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const SpendingsPDF = ({ data, date, user, showType = true }) => {
  // Calculate totals
  const totals = data?.reduce(
    (acc, item) => ({
      regularPrice: acc.regularPrice + (item.regular_price || 0),
      totalPrice: acc.totalPrice + (item.total_price || 0),
      totalTax: acc.totalTax + (item.tax || 0),
    }),
    { regularPrice: 0, totalPrice: 0, totalTax: 0 }
  ) || { regularPrice: 0, totalPrice: 0, totalTax: 0 };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>Izvještaj Troškova</Text>
        <Text style={styles.subHeader}>
          {date} | Korisnik: {user?.username || 'N/A'}
        </Text>

        {data && data.length > 0 ? (
          <>
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>Datum</Text>
                </View>
                {showType && (
                  <View style={styles.tableColHeader}>
                    <Text style={styles.tableCellHeader}>Tip</Text>
                  </View>
                )}
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>Plaćanje</Text>
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>Opis</Text>
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>Osnovica</Text>
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>Ukupno</Text>
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>PDV</Text>
                </View>
              </View>

              {/* Table Body */}
              {data.map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.date}</Text>
                  </View>
                  {showType && (
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{item.spendingType}</Text>
                    </View>
                  )}
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.paymentType}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.description}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.regular_price?.toFixed(2)} €</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.total_price?.toFixed(2)} €</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{item.tax?.toFixed(2)} €</Text>
                  </View>
                </View>
              ))}

              {/* Total Row */}
              <View style={[styles.tableRow, styles.totalRow]}>
                <View style={styles.tableCol}>
                  <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>UKUPNO</Text>
                </View>
                {showType && (
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}></Text>
                  </View>
                )}
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}></Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}></Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>
                    {totals.regularPrice.toFixed(2)} €
                  </Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>
                    {totals.totalPrice.toFixed(2)} €
                  </Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>
                    {totals.totalTax.toFixed(2)} €
                  </Text>
                </View>
              </View>
            </View>

            {/* Summary Section */}
            <View style={styles.summary}>
              <Text style={styles.summaryTitle}>Sažetak</Text>
              <View style={styles.summaryItem}>
                <Text>Ukupan broj stavki:</Text>
                <Text>{data.length}</Text>
              </View>
              <View style={styles.summaryItem}>
                <Text>Ukupna osnovica:</Text>
                <Text>{totals.regularPrice.toFixed(2)} €</Text>
              </View>
              <View style={styles.summaryItem}>
                <Text>Ukupan iznos:</Text>
                <Text>{totals.totalPrice.toFixed(2)} €</Text>
              </View>
              <View style={styles.summaryItem}>
                <Text>Ukupan PDV:</Text>
                <Text>{totals.totalTax.toFixed(2)} €</Text>
              </View>
            </View>
          </>
        ) : (
          <Text style={{ textAlign: 'center', marginTop: 50, fontSize: 14 }}>
            Nema podataka za prikazati
          </Text>
        )}

        {/* Footer */}
        <Text style={{
          position: 'absolute',
          bottom: 30,
          left: 30,
          right: 30,
          textAlign: 'center',
          fontSize: 8,
          color: '#666666'
        }}>
          Generirano: {new Date().toLocaleString('hr-HR')}
        </Text>
      </Page>
    </Document>
  );
};

export default SpendingsPDF;
